export const MAX_BOOKING_PEOPLE = 9;
export const FIRESTORE_REMOVED = 'removed';
export const FIRESTORE_ADDED = 'added';
export const FIRESTORE_MODIFIED = 'modified';

export type FIRESTORE_REMOVED = typeof FIRESTORE_REMOVED;
export type FIRESTORE_ADDED = typeof FIRESTORE_ADDED;
export type FIRESTORE_MODIFIED = typeof FIRESTORE_MODIFIED;

export type FirestoreChangeType = FIRESTORE_ADDED | FIRESTORE_MODIFIED | FIRESTORE_REMOVED;